import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useExportMotivatorsParticipants } from '../../hooks/motivators/Motivators';

const UserRow = React.memo(({ user, type  }) => (
    <tr>
        <td>{user.name}</td>
        <td>{user.surname}</td>
        <td>{user.email}</td>
        <td>
            {user.gdprPromotionsChecked ? <FaCheck glyph="ok" /> : <FaTimes glyph="remove" />}
        </td>
        {type === "COUPON" && <td>{user?.code }</td>}
    </tr>
));

function MotivatorsExport({ id, data }) {


    const { t } = useTranslation();
    const exportParticipants = useExportMotivatorsParticipants(id);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(30);
    const [searchQuery, setSearchQuery] = useState("");

    const handleExport = () => {
        exportParticipants();
    };

    const filteredUsers = useMemo(() => {
        // Ensure data.registered_users is an array before filtering
        const usersArray = Array.isArray(data.registered_users) ? data.registered_users : [];
        return usersArray.filter(user =>
          (user.name && user.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (user.surname && user.surname.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (user.email && user.email.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (user?.code && user?.code.toLowerCase().includes(searchQuery.toLowerCase()))
        );
      }, [data.registered_users, searchQuery]);

    const lastItemIndex = currentPage * itemsPerPage;
    const firstItemIndex = lastItemIndex - itemsPerPage;
    const currentItems = filteredUsers.slice(firstItemIndex, lastItemIndex);

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
    const changePage = (pageNumber) => {
        if(pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    }

    const pagesToShow = 5; // Number of pages to display in the pagination control
    const getPaginationGroup = () => {
        let start = Math.max(currentPage - Math.floor(pagesToShow / 2), 1);
        let end = Math.min(start + pagesToShow - 1, totalPages);

        if (totalPages >= pagesToShow && end - start + 1 < pagesToShow) {
            start = Math.max(end - pagesToShow + 1, 1);
        }

        return Array.from({ length: Math.min(pagesToShow, totalPages) }, (_, i) => start + i);
    };

    return (
        <div className="prizeGame-export prizeGame-more">
            <strong className="unbold">{t("admin.prize.partU")}</strong>
            <div className="langSelectInputWrap langSelectInputWrapUrl float-right">
            <div className="langSelectInput">
                <input
                    type="text"
                    placeholder={t("admin.prize.search")}
                    value={searchQuery}
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1); // Reset to first page on search
                    }}
                />
            </div>
            </div>
            <div className="">
                <table className="table">
                    <thead>
                        <tr>
                            <th>{t("admin.prize.name")}</th>
                            <th>{t("admin.prize.lastname")}</th>
                            <th>{t("admin.prize.email")}</th>
                            <th>{t("admin.prize.promotionsChecked")}</th>
                            {data.type === "COUPON" && <th>{t("admin.prize.cupon")}</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(currentItems) && currentItems.map((user,key) => (
                            <UserRow key={key} user={user} type={data.type} />
                        ))}
                    </tbody>
                </table>
            </div>
            <nav>
                <ul className="pagination pagination-sm fs">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="btn text-sm " style={{ fontSize: '12px' }}   onClick={() => changePage(1)}>
                        &laquo;
                        </button>
                    </li>
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="btn text-sm " style={{ fontSize: '12px' }} onClick={() => changePage(currentPage - 1)}>
                        &lsaquo;
                        </button>
                    </li>
                    {getPaginationGroup().map(pageNumber => (
                        <li key={pageNumber} className={`page-item text-sm`}>
                            <button className={`btn text-sm ${currentPage === pageNumber ? 'active' : ''}`} style={{ fontSize: '12px' }} onClick={() => changePage(pageNumber)}>
                                {pageNumber}
                            </button>
                        </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button className="btn text-sm " style={{ fontSize: '12px' }} onClick={() => changePage(currentPage + 1)}>
                        &rsaquo;
                        </button>
                    </li>
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button className="btn text-sm " style={{ fontSize: '12px' }} onClick={() => changePage(totalPages)}>
                        &raquo;
                        </button>
                    </li>
                </ul>
            </nav>
            <div className="submitMe-field margin-bottom-40">
                <button className="btn btn-export" onClick={handleExport}>{t("admin.prize.expU")}</button>
            </div>
        </div>
    );
}

export default MotivatorsExport;
